import { Title, Flex, Button } from '@mantine/core';
import { modals } from '@mantine/modals';

import { useGetShops } from '@/modules/shops';
import { useCreateShop } from '@/modules/shops';
import { ShopsTable } from '@/modules/shops';
import { CreateShopForm } from '@/modules/shops/ui/create-shop-form';

export const Shops = () => {
  const {
    data: shops = [],
    isLoading,
  } = useGetShops();
  const { handleCreateShop } = useCreateShop();

  const openCreateModal = () => modals.open({
    title: 'Добавление магазина',
    centered: true,
    children: (
      <CreateShopForm
        onSubmit={handleCreateShop}
        onClose={modals.closeAll}
      />
    ),
  });

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Магазины</Title>

        <Button
          variant="filled"
          onClick={openCreateModal}
        >
          Создать
        </Button>
      </Flex>

      <ShopsTable
        items={shops}
        isLoading={isLoading}
      />
    </>
  );
};
